import React, { Component, useState, useEffect } from 'react';
import CatService from '../../service/CatService';
import { TreeSelect } from 'primereact/treeselect';
import { useNavigate, useParams } from 'react-router-dom';
import { CommonDialog } from '../common/CommonDialog';

export function CatTreeSelectLink(){
    var {id} = useParams();
    const navigate = useNavigate();
    return <CatTreeSelect parentId={id} nav={navigate}/>
}
export class CatTreeSelect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            nodes: null,
            loading: true,
            catId: props.value,
            parentId: props.parentId
        };
        this.nodeMap=[];
        console.log('CatTreeSelect:props='+JSON.stringify(this.props));
        this.load();
    }
    componentDidUpdate=(prevProps,prevState)=>{
        if(prevProps.catId!=this.props.catId)
            this.setState({cat:this.props.value});
        if(prevProps.parentId!=this.props.parentId||prevProps.catType!=this.props.catType)
            this.load();
    }    
    componentDidMount() {
    }
    selectionChanged=(event)=>{
        var selectedCat = event.value;
        this.setState({ catId: selectedCat });
        var cat=this.nodeMap[selectedCat];
        if(this.props.onSelect != null)
            this.props.onSelect(cat);
    }
    setCatIcon(cat)
    {
        if (cat.catType == 'ROOT')
            cat.icon = "pi pi-folder";
        else if (cat.catType == 'COURSE')
            cat.icon = "pi pi-book";
        else if (cat.catType == 'TOPIC')
            cat.icon = "pi pi-file";
        else if (cat.catType == 'OUTCOME'||cat.catType == 'OBJECTIVE')
            cat.icon = "pi pi-box";
    }
    valueTemplate=(cat)=>{
        //console.log('valueTemplate:'+JSON.stringify(cat));
        if(cat.length>0)
        {
            return(
                <div className="flex gap-2">
                <div className="text-primary">{cat[0].path}</div>
                <div className="text-500">{cat[0].fullName}</div>
                </div>
            )
        }
        return (<span>{this.props.placeholder?this.props.placeholder:'Not selected'}</span>);
    }
    getChildCatType(cat)
    {
        if(cat.catType == 'ROOT' && cat.parentGroup)
            return 'ROOT';
        else if(cat.catType == 'ROOT' && !cat.parentGroup)
            return 'COURSE';
        else if(cat.catType == 'COURSE')
            return 'TOPIC';
        else if(cat.catType == 'TOPIC')
            return 'TOPIC';
        else if(cat.catType == 'OUTCOME')
            return 'OUTCOME';
        return '';        
    }
    findNode(node,id)
    {
        console.log("CatTreeSelect:findNode");
        if(node.children == undefined)
            return null;
        for(var i = 0; i<node.children.length; i++)
        {
            var ch = node.children[i];
            if(ch.key == id)
                return ch;
            var r = this.findNode(ch,id);
            if(r!=null)
                return r;
        }
        return null;
    }
    load=()=>{
        console.log("CatTreeSelect:load....");
        var ret = CatService.getCatTree(this.state.parentId,this.props.catType,true);
        ret.then(r => {
            var nodes=[];
            this.nodeMap=[];
            r.forEach((cat)=>{
                cat.key = cat.id;
                cat.label = cat.name;
                cat.leaf = true;
                cat.fullName=cat.name;
                cat.children = [];
                this.setCatIcon(cat);
                this.nodeMap[cat.id]=cat;
            });
            this.nodeMap.forEach((node)=>{
                var prnt=this.nodeMap[node.parentId];
                if(prnt==undefined)
                    nodes.push(node);
                else
                {
                    prnt.children.push(node);
                    node.fullName=prnt.fullName+' \\ '+node.name;
                    prnt.leaf=false;
                }
            });
            this.setState({
                nodes: nodes,
                loading: false
            });
        });
    }
    render() {
        return (
            <TreeSelect className="w-full" filterDelay={0} options={this.state.nodes} selectionMode="single" 
                filter filterBy="path,label" filterMode="strict" 
                value={this.state.catId} onChange={this.selectionChanged} 
                valueTemplate={this.valueTemplate} panelStyle={{height:'20rem',overflow:'auto'}}/>
        )
    }
}
export function CatSelectDialog({visible,onOK,onCancel,catType}){
    const [catId,setCatId] = useState(0);

    const onSelect=(cat)=>{
        setCatId(cat.id);
    }
    const _onOK=()=>{
        onOK(catId);
    }
    const _onCancel=()=>{onCancel()};
    return(
        <CommonDialog visible={visible} onOK={_onOK} onCancel={_onCancel} header={"Select a category"}>
            <div className="p-2" style={{width:'400px',height:'100px'}}>
                <CatTreeSelect parentId="0" onSelect={onSelect} catType={catType}></CatTreeSelect>
            </div>
        </CommonDialog>
    );
}
export default CatTreeSelect;